export enum PaymentType {
  CARD = 'CARD',
  SEPA = 'SEPA'
}
